import React, { useContext } from "react";

import Navbar from "../../components/Navbar/navbar";
import CybershieldNavbar from '../../components/Cybershield-component/Cybershield-Navbar/cybershield-navbar'
import { RootContext } from "../../contexts/root-context.js";
import PageInfoDialog from "../../components/PageInfoDialog/PageInfoDialog";
import { PAGE_INFO_DATA } from "../../utils/pageInfoData";

import SBOMUploader from "./Posture/SBOMUploader.js";
function CyberShield() {
    const { showConfigureSBOMPage } = useContext(RootContext);
    return (
      <>
      {/* Page Info Icon - Fixed Position Top Right */}
      <PageInfoDialog pageData={PAGE_INFO_DATA['cybershield']} pageKey="cybershield" />

      
        <Navbar />
     
      {showConfigureSBOMPage ? <SBOMUploader/> :  <CybershieldNavbar/>}
      </>
    );
  }
  
  export default CyberShield;
  

  